import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';

import { BaryModalForm } from '../../../../../../../../models/bary-modal-form';
import { BaryComponentHelper } from '../../../../../../util/bary-component-helper';
import { IBaryModalEvent } from '../../../../../../../../models/bary-modal-event';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { FaDirectiveEnum } from '../../../../../../../../models/enums/fa-directive.enum';

@Component({
  templateUrl: './popin-evt-transport.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopinEvtTransportComponent extends BaryModalForm implements OnDestroy {
  private modalRef = inject(MDBModalRef);

  public override action = BaryComponentHelper.generateAction<IBaryModalEvent>();

  public messages!: string[];

  protected readonly FAS = FaDirectiveEnum.FAS;

  constructor() {
    super();
  }

  public handleClick(event: IBaryModalEvent): void {
    this.action.next(event);
    this.modalRef.hide();
  }

  public override handleSubmit(event: IBaryModalEvent): void {
    this.action.next(event);
    this.modalRef.hide();
  }
}
